<template>
  <div class="container">
    <el-form ref="searchForm" :rules="rulesSearch" :model="forms" class="search-form">
      <el-form-item label="用劵用户手机号" prop="thirdBuyer">
        <el-input
          v-model="forms.thirdBuyer"
          placeholder="用劵用户手机号"
          style="width: 200px"
        ></el-input>
      </el-form-item>
      <el-form-item label="优惠券名称">
        <el-input
          v-model="forms.couponName"
          placeholder="优惠券名称"
          style="width: 200px"
        ></el-input>
      </el-form-item>
      <el-form-item label="优惠券状态">
        <el-select v-model="forms.status" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="影票订单号">
        <el-input
          v-model="forms.orderId"
          placeholder="影票订单号"
          style="width: 200px"
        ></el-input>
      </el-form-item>
      <el-form-item label="领券时间">
        <el-date-picker
          v-model="forms.createTimeArr"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="daterange"
          range-separator="至"
          start-placeholder="领券开始日期"
          end-placeholder="领券结束日期"
          :default-time="['00:00:00', '23:59:59']"
          @change="changeTimesValue"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="用券时间">
        <el-date-picker
          v-model="forms.useTimeArr"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="daterange"
          range-separator="至"
          start-placeholder="用券开始日期"
          end-placeholder="用券结束日期"
          :default-time="['00:00:00', '23:59:59']"
          @change="changeTimesValueEnd"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="warning" @click="search">查询</el-button>
        <el-button type="warning" plain @click="reset">重置</el-button>
        <el-button @click="exportTable">导出数据</el-button>
      </el-form-item>
    </el-form>

    <my-table
      :tableData="table.tableData"
      :headerList="table.headerList"
      :loading="table.loading"
      :page-size="searchForm.pageSize"
      :currentPage="searchForm.pageNo"
      :total="table.total"
      @currentPage-change="handlePageChange"
      @sizePage-change="handleSizeChange"
    >
    </my-table>
  </div>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini();
import myTable from '@/components/my-table.vue'
import debounce from "@/utils/debounce.js";
import { formatDate } from "@/utils/date.js";
export default {
  components: {
    myTable
  },
  data() {
    return {
      couponPlatformType:'50',
      rulesSearch:{
        thirdBuyer: [
          { validator: this.validateNumber, trigger: 'blur' } // 自定义校验规则
        ]
      },
      searchForm: {
        pageNo: 1,
        pageSize: 10,
      },
      forms: {
        thirdBuyer: "",
        couponName: "",
        createTimeArr: [],
        status: "",
        orderId:'',
        useTimeArr: [],
      },
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "待使用",
        },
        {
          value: 1,
          label: "已使用",
        },
        {
          value: 2,
          label: "已核销",
        },
      ],
      table:{
        loading:false,
        total:0,
        tableData: [],
        headerList:[
          {
            prop: 'userTag',
            label: '用券用户手机号',
            width: '120',
            // customRender:'customName'
          },
          {
            prop: 'createTimeStr',
            label: '领券时间',
            width: '160',
          },
          {
            prop: 'couponName',
            label: '券名称',
            width: '180',
            // customRender:'createStatusStr'
          },
          {
            prop: 'cheaperPriceBd',
            label: '券面值',
            width: '120',
            // customRender: 'cheaperPriceBd'
          },
          // {
          //   prop: 'code',
          //   label: '核销券码',
          //   width: '150',
          //   // customRender: 'couponValue'
          // },
          {
            prop: 'statusStr',
            label: '券使用状态',
            width: '120'
          },
          {
            prop: 'orderId',
            label: '用券影票订单号',
            width: '120'
          },
          {
            prop: 'initPriceBd',
            label: '市场价',
            width: '120'
          },
          {
            prop: 'guidePriceBd',
            label: '指导价',
            width: '120'
          },
          {
            prop: 'couponPayPriceBd',
            label: '券后支付价',
            width: '120'
          },
          {
            prop: 'useTimeStr',
            label: '用券时间',
            width: '120',
          },
        ]
      },
    }
  },
  methods:{
    // 优惠券使用情况-列表
    async getList() {
      let appKeyMini = localStorage.getItem("appKeyMini");
      // 领券时间
      let createTimeStart = ''
      let createTimeEnd = ''
      // 用券时间
      let useTimeStart = ''
      let useTimeEnd = ''
      console.log(this.forms,'this.forms==')
      if(Array.isArray(this.forms.createTimeArr) && this.forms.createTimeArr.length) {
        createTimeStart = this.forms.createTimeArr[0]
        createTimeEnd = this.forms.createTimeArr[1]
      }else{
        createTimeStart = ''
        createTimeEnd = ''
      }
      if(Array.isArray(this.forms.useTimeArr) && this.forms.useTimeArr.length) {
        useTimeStart = this.forms.useTimeArr[0]
        useTimeEnd = this.forms.useTimeArr[1]
      }else{
        useTimeStart = ''
        useTimeEnd = ''
      }
      this.table.loading = true;
      const res = await MiniModel.couponSearchMarket({
        ...this.forms,
        ...this.searchForm,
        appKey:appKeyMini,
        createTimeStart,
        createTimeEnd,
        useTimeStart,
        useTimeEnd,
        couponPlatformType: this.couponPlatformType,
      }).finally(() => {
        this.table.loading = false;
      })
      if(res.data.code === 200) {
        this.table.tableData = res.data.data.list.map(item => {
          return {
            ...item,
            cheaperPriceBd: item.cheaperPriceBd ? item.cheaperPriceBd : '-',
          }
        })
        this.table.total = res.data.data.total;
        this.searchForm.pageNo = res.data.data.pageNo
        console.log(this.table.tableData,'this.table.tableData')
      }else{
        this.$message({
          message: res.data.message,
          type: 'error'
        });
      }
      console.log(res,'优惠券使用情况-列表==')
    },
    changeTimesValue(val) {
      if(!val) {
        this.forms.createTimeArr = []
      }
      // this.forms.createTimeArr = val;
    },
    changeTimesValueEnd(val) {
      console.log(val,'val==')
      if(!val) {
        this.forms.useTimeArr = []
      }
      // this.forms.useTimeArr = val;
    },
    search() {
      debounce(()=> {
        this.$refs['searchForm'].validate((valid) => {
          if (valid) {
            this.searchForm.pageNo = 1
            this.searchForm.pageSize = 10
            this.getList()
          } else {
            return false;
          }
        });
        // this.searchForm.pageNo = 1
        // this.searchForm.pageSize = 10
        // this.getList()
      },500,true)
    },
    reset() {
      debounce(()=> {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
        this.forms.thirdBuyer = ''
        this.forms.couponName = ''
        this.forms.status = ''
        this.forms.orderId = ''
        this.forms.createTimeArr = ""
        this.forms.useTimeArr = ""
        this.getList()
      },500,true)
    },
    async exportTable() {
      let appKeyMini = localStorage.getItem("appKeyMini");
      // 领券时间
      let createTimeStart = ''
      let createTimeEnd = ''
      // 用券时间
      let useTimeStart = ''
      let useTimeEnd = ''
      if(this.forms.createTimeArr.length) {
        createTimeStart = this.forms.createTimeArr[0]
        createTimeEnd = this.forms.createTimeArr[1]
        useTimeStart = this.forms.useTimeArr[0]
        useTimeEnd = this.forms.useTimeArr[1]
      }else{
        createTimeStart = ''
        createTimeEnd = ''
        useTimeStart = ''
        useTimeEnd = ''
      }
      const res = await MiniModel.couponExportV3Market({
        ...this.forms,
        ...this.searchForm,
        appKey:appKeyMini,
        createTimeStart,
        createTimeEnd,
        miniAppType:4,
        couponPlatformType: this.couponPlatformType,
      })
      const code = res.data.code
      const message = res.data.message
      if (code === 200) {
        await this.$alert(`当前数据下载中，请前往 导出中心 查看`, '导出数据提示', {
          showCancelButton: true,
          confirmButtonText: '前往导出列表',
          cancelButtonText: '取消',
          callback: action => {
            if(action === 'confirm'){
              this.$router.push({ path: "/pc/exportCenter/index" });
            }
            this.exportLoading = false
          }
        });
      } else {
        this.$Message.error(message)
      }
      // if(res.status == 200) {
      //   const blob = new Blob([res.data], {
      //     type: "application/vnd.ms-excel",
      //   });
      //   let url = window.URL.createObjectURL(blob);
      //   var a = document.createElement("a");
      //   document.body.appendChild(a);
      //   a.href = window.URL.createObjectURL(blob);
      //   a.download = "支付宝优惠券使用情况导出_" + formatDate('yyyy-MM-dd') + ".xls";
      //   a.click();
      //   window.URL.revokeObjectURL(url);
      // }
    },
    // 分页
    handlePageChange(val) {
      this.searchForm.pageNo = val
      this.getList()
    },
    // 每页显示条数
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.getList()
    },
    // 自定义的数字校验规则
    validateNumber(rule, value, callback) {
      if (value === '') {
        // 如果值为空，不做任何校验
        callback();
      } else if (!/^\d+$/.test(value)) {
        // 如果值不为空，并且不是数字，报错
        callback(new Error('请输入数字'));
      } else {
        // 如果值是数字，校验通过
        callback();
      }
    },
  }
}
</script>

<style scoped lang="less">
/deep/.el-range-separator {
  width: 10% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/couponGroupNew/couponUsage.vue